import ChevronDown from '@sats-group/icons/24/arrow-down';
import ChevronUp from '@sats-group/icons/24/arrow-up';
import Button from '@sats-group/ui-lib/react/button';
import Collapse from '@sats-group/ui-lib/react/collapse/collapse';
import Text from '@sats-group/ui-lib/react/text';
import React, { useState } from 'react';
import WebAdminLayout from '~/client/components/web-admin-layout/web-admin-layout';
import type { WebAdminSettings as Props } from './web-admin-settings.types';
import type { WebAdminSettingsCodeTable as TableProps } from './web-admin-settings-code-table.types';
import type { WebAdminSettingsSection as SectionProps } from './web-admin-settings-section.types';

const WebAdminSettingsCodeTable: React.FunctionComponent<TableProps> = ({
  header,
  rows,
  title,
}) => (
  <table data-title={title} style={{ width: '100%' }}>
    <thead>
      <tr>
        {header.map(text => (
          <td key={text}>{text}</td>
        ))}
      </tr>
    </thead>
    <tbody>
      {rows.map(texts => (
        <tr key={texts.join('')} style={{ verticalAlign: 'top' }}>
          {texts.map(text => (
            <td key={text}>
              <Text
                elementName="code"
                size={Text.sizes.small}
                style={{ wordBreak: 'break-word' }}
              >
                {text}
              </Text>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

const WebAdminSettingsSection: React.FunctionComponent<
  React.PropsWithChildren<SectionProps>
> = ({ children, title }) => {
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded(expanded => !expanded);

  return (
    <div className="web-admin-settings__section">
      <div className="web-admin-settings__section-header">
        <Text elementName="h2" size={Text.sizes.headline2} onClick={toggle}>
          {title}
        </Text>
        <Button
          iconOnly
          leadingIcon={expanded ? <ChevronUp /> : <ChevronDown />}
          onClick={toggle}
          size={Button.sizes.large}
          text={
            expanded ? `Hide section "${title}"` : `Show section "${title}"`
          }
        />
      </div>
      <Collapse isOpen={expanded}>
        <div className="web-admin-settings__section-content">{children}</div>
      </Collapse>
    </div>
  );
};

const WebAdminSettings: React.FunctionComponent<Props> = ({ info, layout }) => (
  <WebAdminLayout {...layout}>
    <div className="web-admin-settings">
      {info.map(group => (
        <WebAdminSettingsSection key={group.title} title={group.title}>
          {group.description ? (
            <Text elementName="p">{group.description}</Text>
          ) : null}
          <WebAdminSettingsCodeTable {...group} />
        </WebAdminSettingsSection>
      ))}
    </div>
  </WebAdminLayout>
);

export default WebAdminSettings;
